<template>
    <div>

        <div class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Група</label>
            <div class="col-md-9">
                <multiselect
                    v-model="group"
                    label="name"
                    track-by="id"
                    :options="groups"
                    :multiple="true"
                    open-direction="bottom"
                    @input="getPrograms">
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="group">
            <label class="col-form-label text-md-right col-md-2">Програма</label>
            <div class="col-md-9">
                <multiselect
                    v-model="program"
                    label="name"
                    track-by="id"
                    :options="programs"
                    :multiple="true"
                    open-direction="bottom"
                    @input="clearData"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row" v-if="group">
            <label class="col-form-label text-md-right col-md-2">Дата початку </label>
            <div class="col-md-9">
                <div class="input-group input-group--custom">
                    <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                    <datetime
                        v-model="start_date"
                        class="flatpickr">
                    </datetime>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="group">
            <label class="col-form-label text-md-right col-md-2">Дата кінця </label>
            <div class="col-md-9">
                <div class="input-group input-group--custom">
                    <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                    <datetime
                        v-model="finish_date"
                        class="flatpickr">
                    </datetime>
                </div>
            </div>
        </div>

        <div class="row" v-if="finish_date">
            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="getReportStudentsLearningGap" :disabled="submiting"  type="button">
                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                Завантажити звіт
            </button>	&nbsp;	&nbsp;

            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="saveReportStudentsLearningGap" :disabled="submiting" type="button">
                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                Зберегти звіт
            </button>
            <br>
            <br>
        </div>

        <div class="row">
            <div class="col-12 table-reports">
                <table class="table is_middle table-condensed table-bordered">
                    <template v-for="teacher in students_result">
                        <tr>
                            <td style="background: #ccc">{{ teacher.name }}</td>
                        </tr>

                        <template v-for="program in teacher.programs">
                            <tr>
                                <td style="background: #ececec">{{ program.name }}</td>
                            </tr>
                            <template v-for="group in program.groups">
                                <tr>
                                    <td style="background: #f5f5f5">{{ group.name }}</td>
                                </tr>
                                <template v-for="student in group.students">
                                    <tr>
                                        <td>{{ student.name }}</td>
                                        <td>{{ student.counts }}</td>
                                        <template v-for="lesson in student.unfinished_lessons">
                                            <td>{{ lesson }}</td>
                                        </template>
                                    </tr>
                                </template>
                            </template>
                        </template>

                    </template>
                </table>
            </div>
        </div>

    </div>

</template>
<style scoped>
    .table-reports {
        overflow-x: auto;
        max-width: 100%;
    }
    .table-reports:empty {
        display: none;
    }
    tr td:first-child{
        min-width: 300px;
    }
    .table-reports{
        overflow-x: scroll;
        max-width: 100%;
    }
    .table-reports tr td {
        padding: 8px;
        min-width: 95px;
    }
    .table-reports tr td:first-child {
        min-width: 210px;
    }
</style>
<script>
    import axios from "axios";

    export default {
        name: "TeacherReportsAverageScoreComponent",
        props: [ 'groups'],
        data() {
            return {

                submiting: false,

                group: null,

                program: null,
                programs: [],

                finish_date: null,
                start_date: null,

                students_result: []
            }
        },
        computed: {},
        mounted() {

        },
        methods: {

            clearData(){
                this.on_date = null;
            },

            async getPrograms(){
                const { data: { programs } } = await axios.post('/teacher/dashboard/reports/getPrograms', {
                    'groups': this.group,
                });
                this.programs = programs;
            },

            async getReportStudentsLearningGap(){
                this.submiting = true;
                const result = await axios.post('/teacher/dashboard/reports/getReportStudentsLearningGap', {
                    'groups': this.group,
                    'programs': this.program,
                    'start_date': this.start_date,
                    'finish_date': this.finish_date,
                });

                this.students_result = result.data.students_result
                this.submiting = false;
            },

            async saveReportStudentsLearningGap(){
                this.submiting = true;
                const result = await axios.post('/teacher/dashboard/reports/getReportStudentsLearningGap', {
                    'groups': this.group,
                    'programs': this.program,
                    'start_date': this.start_date,
                    'finish_date': this.finish_date,
                    'save': true,
                });

                location.href = result.data.file_name
                this.submiting = false;
            }
        }
    }
</script>
